import React, { useEffect, useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Box, Typography, Tooltip, IconButton } from "@mui/material";
import Close from "@mui/icons-material/Close";
import { updateBadgeForTicket } from "../../../../redux/features/adminEventsSlice";

const ProgramBadgeModel = ({ open, event, ticketId, handleClose, ndef }) => {
  const dispatch = useDispatch();
  const { id: eventId, tickets } = event || {};
  const ticket = (tickets || []).find(({ id }) => id === ticketId);
  const { displayName } = ticket || {};
  const [displayMessage, setDisplayMessage] = useState("");

  const beginListening = useCallback(async () => {
    setDisplayMessage("Waiting for badge...");
    try {
      await ndef.scan();
      ndef.onreadingerror = (e) => {
        setDisplayMessage("error: " + e);
        window.alert("error: " + e);
      };
      ndef.onreading = async ({ message, serialNumber }) => {
        setDisplayMessage("Found badge, now writing");
        await ndef.write(ticketId);
        // await ndef.makeReadOnly();
        setDisplayMessage("Writing complete");
        await dispatch(
          updateBadgeForTicket({ eventId, ticketId, serialNumber }),
        );

        handleClose();
      };
    } catch (e) {
      ndef.onreadingerror = null;
      ndef.onreading = null;
      setDisplayMessage("error: " + e);
    }
  }, [ndef, ticketId, eventId, dispatch, handleClose]);

  useEffect(() => {
    if (open) {
      beginListening();
    }
  }, [open, beginListening]);

  if (!ticket) {
    return null;
  }

  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "100%", sm: "100%", md: 600 },
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
          maxHeight: "90vh",
          overflow: "auto",
        }}
      >
        <Box display={"flex"}>
          <Typography flexGrow={"1"} variant="h6">
            {`Program Badge for ${displayName}`}
          </Typography>
          <Tooltip title="Close">
            <IconButton
              onClick={() => {
                handleClose();
              }}
            >
              <Close />
            </IconButton>
          </Tooltip>
        </Box>
        <Box>
          <Typography>{displayMessage}</Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default ProgramBadgeModel;
